export default function init() {
	class TEXTTOSPEECH {
		static SELECTOR_CLASS_TTS = '.jtf__tts'
		static SELECTOR_CLASS_WP_ADMIN = '.wp-admin'
		static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-tts'
		static ATTR_DATA_PLAYERID = 'data-playerid'
		static TIMEOUT_DELAY_ADMIN = 9000
		static API_ENDPOINT = '/wp-json/jtf/v1/audio/retrievetts'
		static PROP_AUTH_FAIL = 'auth_fail'
		static PROP_NO_AUDIO_DATA = 'no_audio_data'
		static EVENT_PLAY = 'play'
		static EVENT_ENDED = 'ended'
		static EVENT_TTS_AUDIO = 'ttsAudioEvent'

		constructor( instance ) {
			this.instance = instance
			this.getAudioFromServer()
		}

		// noinspection FunctionWithMoreThanThreeNegationsJS
		async getAudioFromServer() {
			const ttsElement = this.instance.querySelector( TEXTTOSPEECH.SELECTOR_CLASS_TTS )
			if ( !ttsElement ) {
				return
			}

			const playerId = ttsElement.getAttribute( TEXTTOSPEECH.ATTR_DATA_PLAYERID )

			try {
				const response = await fetch(
					`${ TEXTTOSPEECH.API_ENDPOINT }?playerid=${ playerId }&auth=${ localObject.jtfRegKey }`,
					{
						method: 'GET',
						headers: {
							'Content-Type': 'application/json',
						},
					},
				)

				if ( !response.ok ) {
					throw new Error( `Error! status: ${ response.status }` )
				}

				const fetchResponseData = await response.json()

				if (
					fetchResponseData !== TEXTTOSPEECH.PROP_AUTH_FAIL &&
					fetchResponseData !== TEXTTOSPEECH.PROP_NO_AUDIO_DATA
				) {
					this.createAudioPlayer( fetchResponseData, playerId )
				}
			} catch ( error ) {
				// Error handling
			}
		}

		createAudioPlayer( audioUrl, playerId ) {
			if ( audioUrl && playerId ) {
				const audioElements = this.instance.querySelectorAll( 'audio' )
				audioElements.forEach( ( el ) => {
					el.remove()
				} )

				const labelId = 'jtf__tts--label-' + playerId

				const audioElement = document.createElement( 'audio' )
				audioElement.controls = true
				audioElement.autoplay = false
				audioElement.src = audioUrl
				audioElement.setAttribute( 'aria-labelledby', labelId )

				const container = document.getElementById( 'jtf__tts--' + playerId )
				if ( container ) {
					container.appendChild( audioElement )
				}

				audioElement.addEventListener( TEXTTOSPEECH.EVENT_PLAY, ( e ) => {
					if ( typeof dataLayer !== 'undefined' ) {
						dataLayer.push( {
							'event': TEXTTOSPEECH.EVENT_TTS_AUDIO,
							'ttsAudioAction': TEXTTOSPEECH.EVENT_PLAY,
							'ttsAudioTitle': e.target.src,
						} )
					}
				} )

				audioElement.addEventListener( TEXTTOSPEECH.EVENT_ENDED, ( e ) => {
					if ( typeof dataLayer !== 'undefined' ) {
						dataLayer.push( {
							'event': TEXTTOSPEECH.EVENT_TTS_AUDIO,
							'ttsAudioAction': TEXTTOSPEECH.EVENT_ENDED,
							'ttsAudioTitle': e.target.src,
						} )
					}
				} )
			}
		}
	}

	const wpAdmin = document.querySelector( TEXTTOSPEECH.SELECTOR_CLASS_WP_ADMIN )
	if ( wpAdmin ) {
		setTimeout( () => {
			const blocks = document.querySelectorAll( TEXTTOSPEECH.SELECTOR_CLASS_BLOCK )
			if ( blocks.length > 0 ) {
				blocks.forEach( ( block ) => {
					new TEXTTOSPEECH( block )
				} )
			}
		}, TEXTTOSPEECH.TIMEOUT_DELAY_ADMIN )
	} else {
		const blocks = document.querySelectorAll( TEXTTOSPEECH.SELECTOR_CLASS_BLOCK )
		if ( blocks.length > 0 ) {
			blocks.forEach( ( block ) => {
				new TEXTTOSPEECH( block )
			} )
		}
	}
}
